import PropTypes from 'prop-types';
import React from 'react';

import CardCarousel from 'components/CardCarousel';
import { Small, MediumUp } from 'components/MediaQuery';
import { BACKGROUND_TYPES } from 'constants/landingPage';
import { mediumUp } from 'constants/mediaQueries';
import PageSectionAssetDecoratedCarouselModel from 'models/PageSectionAssetDecoratedCarousel';
import Theme from 'styles/theme';

import BackgroundImage from './BackgroundImage';
import BackgroundVideo from './BackgroundVideo';

const PageSectionAssetDecoratedCarousel = ({ data, trackEvent }) => {
  const {
    landscapeAsset,
    portraitAsset,
    landscapeBackgroundType,
    portraitBackgroundType,
    carousel,
  } = data;

  return (
    <div className="PageSectionAssetDecoratedCarousel">
      <div className="PageSectionAssetDecoratedCarousel__image-wrapper">
        <Small>
          {portraitBackgroundType === BACKGROUND_TYPES.VIDEO && (
            <BackgroundVideo asset={portraitAsset} />
          )}
          {portraitBackgroundType === BACKGROUND_TYPES.IMAGE && (
            <BackgroundImage asset={portraitAsset} />
          )}
        </Small>
        <MediumUp>
          {landscapeBackgroundType === BACKGROUND_TYPES.VIDEO && (
            <BackgroundVideo asset={landscapeAsset} />
          )}
          {landscapeBackgroundType === BACKGROUND_TYPES.IMAGE && (
            <BackgroundImage asset={landscapeAsset} />
          )}
        </MediumUp>
      </div>
      <CardCarousel data={carousel} trackEvent={trackEvent} />
      <style jsx>
        {`
          .PageSectionAssetDecoratedCarousel__image-wrapper {
            height: calc(85vh - ${Theme.get('top-navigation-height')}px);
            min-height: 500px;
          }

          @media ${mediumUp} {
            .PageSectionAssetDecoratedCarousel__image-wrapper {
              height: calc(100vh - ${Theme.get('top-navigation-height')}px);
            }
          }
        `}
      </style>
      <style jsx global>
        {`
          .PageSectionAssetDecoratedCarousel .CardCarousel {
            margin-top: -${Theme.get('spacing') * 30}px;
          }

          @media ${mediumUp} {
            .PageSectionAssetDecoratedCarousel .CardCarousel {
              margin-top: -${Theme.get('spacing') * 35}px;
            }
          }

          .PageSectionAssetDecoratedCarousel .CardCarousel .typography--secondary-heading,
          .PageSectionAssetDecoratedCarousel
            .CardCarousel
            .CardCarousel__heading-section-paragraph.Paragraph {
            position: relative;
            color: ${Theme.get('colors-white')};
          }
        `}
      </style>
    </div>
  );
};

PageSectionAssetDecoratedCarousel.propTypes = {
  data: PropTypes.instanceOf(PageSectionAssetDecoratedCarouselModel).isRequired,
  trackEvent: PropTypes.func,
};

PageSectionAssetDecoratedCarousel.defaultProps = {
  trackEvent: () => {},
};

export default PageSectionAssetDecoratedCarousel;
